"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextChoiceButtons = void 0;
const material_1 = require("@mui/material");
const react_1 = __importStar(require("react"));
const TextButton_1 = require("./TextButton");
const framer_motion_1 = require("framer-motion");
const animations_1 = require("../../animations");
const TextChoiceButtons = ({ choices, highlightedChoices, disabled, className, gameplayStyle: componentStyle, onInteract, height, width, identifiersForAnimation, onAnimationComplete, }) => {
    var _a;
    const controls = (_a = choices === null || choices === void 0 ? void 0 : choices.map(() => (0, framer_motion_1.useAnimation)())) !== null && _a !== void 0 ? _a : [];
    (0, react_1.useEffect)(() => {
        console.log(identifiersForAnimation);
    }, [identifiersForAnimation]);
    (0, react_1.useEffect)(() => {
        async function startAnimations() {
            if (!identifiersForAnimation || !onAnimationComplete) {
                return;
            }
            if (!identifiersForAnimation.some(id => {
                return choices.includes(id);
            })) {
                onAnimationComplete(identifiersForAnimation);
                return;
            }
            if (choices.length !== controls.length) {
                onAnimationComplete(identifiersForAnimation);
                return;
            }
            await Promise.all(identifiersForAnimation.map(id => {
                const indexInImageNames = choices.findIndex(name => name === id);
                if (indexInImageNames > -1) {
                    return controls[indexInImageNames].start(animations_1.shakeAnimation);
                }
                return;
            }));
            onAnimationComplete(identifiersForAnimation);
        }
        startAnimations();
    }, [identifiersForAnimation, controls, onAnimationComplete]);
    return (react_1.default.createElement(material_1.Grid, { container: true, columnGap: 1.5, rowGap: 1.5, justifyContent: "center", width: width ? `${width}` : '100%', height: height ? `${height}` : '100%' }, choices.map((text, index) => {
        return (react_1.default.createElement(material_1.Grid, { item: true, key: text, xs: 10, sm: 10, md: 3.5, lg: 3.5, xl: 3.5, container: true, justifyContent: "center", alignItems: "stretch" },
            react_1.default.createElement(framer_motion_1.motion.div, { key: choices[index], animate: controls[index], style: { width: '100%' } },
                react_1.default.createElement(TextButton_1.TextButton, { text: text, onInteract: onInteract, disabled: disabled, highlighted: highlightedChoices.includes(text), blurred: highlightedChoices.length > 0 &&
                        !highlightedChoices.includes(text), className: className, gameplayStyle: componentStyle }))));
    })));
};
exports.TextChoiceButtons = TextChoiceButtons;
